export default __webpack_public_path__ + "static/Entenda0085-b5e970c926b3c88c41ca378b348affd5.jpg";